module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAABEElEQVRIie3WvU3DUBTF8T+WB3B9K0bwCMkEZAQqt7AByQYZASaADfAIyQahOTVMAIUdyYmc+H1cUyBO6Xekn2w/Xd2bpmkAKuAOuCUtBzN7CS2XPfgO1IkgAJL2ZrYL6RbAKhcEvoBDaLnk9JNugHWMZmaTHUkV8Npby/LsPAoMSQ8Of9+i8EYmwL2ZPc+GjoHAArqL9GugmX3Ogk6B7mgI6IqGgm5oDOiCxoIeaDSYiyaBOWgymINuU8Ec9JiLoKStpG9JKy/0HlgC9ZU3fBh0XVCANrBXeaLJ+Uf/PvrEyG2LjaTHa+clMFyQ10RuhJKmKu35gwJ4o5ssc+SDbmSe5Lj31vhs+sPsgHZsYv0AyWhv53OqxcsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/redact.png
// module id = HiPE
// module chunks = 1